/** Alphabetical by `name` — same as persisted operator list / Download All sequence. */
export function sortCatalogByDisplayName<T extends { name: string }>(catalog: T[] | null): T[] | null {
  if (!catalog?.length) return catalog;
  return [...catalog].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}
